const searchBtn = document.querySelector('#downloads-btn');

if (searchBtn) {
    const citySelect = document.querySelector('#city-select');
    const statusSelect = document.querySelector('#status-select');
    const noFiles = document.querySelector('#no-files');
    const filesDiv = document.querySelector('#files');
    const loader = document.querySelector('#files-loader');

    searchBtn.addEventListener('click', () => {
        const cityValue = citySelect.value;
        const statusValue = statusSelect.value;

        filesDiv.parentElement.style.display = 'none';

        if (cityValue.length > 0 && statusValue.length > 0) {
            citySelect.classList.remove('downloads-error');
            statusSelect.classList.remove('downloads-error');

            filesDiv.innerHTML = '';

            noFiles.style.display = 'none';
            loader.style.display = 'block';

            fetch(`${document.location.origin}/wp-json/wp/v2/miasta/${cityValue}`)
                .then((jsonData) => jsonData.json())
                .then((data) => loadCity(data));

            const loadCity = (city) => {
                const files = city.acf.files;
                loader.style.display = 'none';

                if (files) {
                    files.forEach((obj) => {
                        let canBeRendered = false;

                        const objWrapper = document.createElement('div');
                        objWrapper.className = 'mb-8 md:mb-16 last:mb-0';

                        const filesWrapper = document.createElement('ul');

                        const heading = document.createElement('h3');
                        heading.className = 'text-2xl mb-6';
                        heading.innerText = obj.heading;

                        const subRepeater = obj.item;

                        subRepeater.forEach((el) => {
                            if (el.status.indexOf(statusValue) !== -1) {
                                const fileItem = document.createElement('li');

                                fileItem.innerHTML = `
                                    <a target="_blank" href="${
                                        el.file ? el.file : '#'
                                    }" class="group flex flex-col mb-2 p-4 md:p-8 lg:px-16 lg:py-8 rounded border border-solid border-lightBig md:flex-row md:items-stretch hover:shadow-card transition-shadow duration-300">
                                            <div class="flex items-center shrink-0 md:mr-8 lg:mr-16">
                                                <div class="w-[20px] h-[20px]">
											    <?xml version="1.0" encoding="UTF-8"?>
											    <svg width="13px" height="20px" viewBox="0 0 13 20" version="1.1" xmlns="http://www.w3.org/2000/svg"     xmlns:xlink="http://www.w3.org/1999/xlink">
												    <title>icons/ui/attachment</title>
												    <g id="Projekt" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
													    <g id="04-Czempin" transform="translate(-508.000000, -10742.000000)" fill="#2D7DE0" fill-rule="nonzero">
														    <g id="Group-10" transform="translate(48.000000, 10384.000000)">
															    <g id="attachment" transform="translate(460.000000, 358.000000)">
                                                                <path d="M6.25,20 C2.80395833,20 0,17.1960417 0,13.75 L0,5.625 C0,5.27958333 0.279583333,5 0.625,5 C0.970416667,5 1.25,5.27958333 1.25,5.625 L1.25,13.75 C1.25,16.506875 3.493125,18.75 6.25,18.75 C9.006875,18.75 11.25,16.506875 11.25,13.75 L11.25,4.375 C11.25,2.651875 9.848125,1.25 8.125,1.25 C6.401875,1.25 5,2.651875 5,4.375 L5,13.75 C5,14.4391667 5.56083333,15 6.25,15 C6.93916667,15 7.5,14.4391667 7.5,13.75 L7.5,5.625 C7.5,5.27958333 7.77958333,5 8.125,5 C8.47041667,5 8.75,5.27958333 8.75,5.625 L8.75,13.75 C8.75,15.12875 7.62875,16.25 6.25,16.25 C4.87125,16.25 3.75,15.12875 3.75,13.75 L3.75,4.375 C3.75,1.96291667 5.71291667,0 8.125,0 C10.5370833,0 12.5,1.96291667 12.5,4.375 L12.5,13.75 C12.5,17.1960417 9.69604167,20 6.25,20 Z" id="Attachment"></path>
															    </g>
														    </g>
													    </g>
												    </g>
											    </svg>
										    </div>
                                        </div>
                                        <div class="my-3 md:pr-6">
                                            <h4 class="mb-1 text-xl font-normal group-hover:text-blue_light transition-colors duration-300">${
                                                el.name
                                            }</h4>
                                            <p class="text-sm text-main ">
                                                Aktualizacja:
                                                ${el.update}
                                            </p>
                                        </div>
                                        <div class="flex items-center border-light_big md:border-l md:ml-auto md:pl-[50px] lg:pl-[100px]">
                                            <div class="w-[113px] flex justify-end items-center text-sm font-bold text-dark">
                                            <div class="mr-4 transition-all duration-300 group-hover:mr-[-15px]">
                                            <?xml version="1.0" encoding="UTF-8"?><svg width="20px" height="19px" viewBox="0 0 20 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <title>icons/ui/download</title> <g id="Projekt" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="04-Czempin" transform="translate(-1303.000000, -10743.000000)" fill="#0A213D" fill-rule="nonzero"> <g id="Group-10" transform="translate(48.000000, 10384.000000)"> <g id="download" transform="translate(1255.000000, 359.000000)"> <path class="group-hover:fill-blue_light" d="M16.4285714,18.5714286 L3.57142857,18.5714286 C1.60214286,18.5714286 0,16.9692857 0,15 L0,9.28571429 C0,8.89095238 0.31952381,8.57142857 0.714285714,8.57142857 C1.10904762,8.57142857 1.42857143,8.89095238 1.42857143,9.28571429 L1.42857143,15 C1.42857143,16.1816667 2.3897619,17.1428571 3.57142857,17.1428571 L16.4285714,17.1428571 C17.6102381,17.1428571 18.5714286,16.1816667 18.5714286,15 L18.5714286,9.28571429 C18.5714286,8.89095238 18.8909524,8.57142857 19.2857143,8.57142857 C19.6804762,8.57142857 20,8.89095238 20,9.28571429 L20,15 C20,16.9692857 18.3978571,18.5714286 16.4285714,18.5714286 Z M14.0764286,8.06642857 C13.797381,7.78738095 13.3454762,7.78738095 13.0664286,8.06642857 L10.7142857,10.4185714 L10.7142857,0.714285714 C10.7142857,0.31952381 10.3947619,0 10,0 C9.6052381,0 9.28571429,0.31952381 9.28571429,0.714285714 L9.28571429,10.4185714 L6.93357143,8.06642857 C6.65452381,7.78738095 6.20261905,7.78738095 5.92357143,8.06642857 C5.64452381,8.34547619 5.64452381,8.79738095 5.92357143,9.07642857 L9.495,12.6478571 C9.63452381,12.787381 9.81714286,12.8571429 10,12.8571429 C10.1828571,12.8571429 10.3654762,12.787381 10.505,12.6478571 L14.0764286,9.07642857 C14.3554762,8.79738095 14.3554762,8.34547619 14.0764286,8.06642857 Z" id="Download"></path> </g> </g> </g> </g></svg>
                                            </div>
                                            <span class="transition duration-300 group-hover:opacity-0">Pobierz plik</span>
                                            </div>
                                        </div>
                                    </a>
                                `;

                                filesWrapper.appendChild(fileItem);
                                canBeRendered = true;
                            } else {
                                canBeRendered = false;
                            }
                        });

                        if (canBeRendered) {
                            objWrapper.appendChild(heading);
                            objWrapper.appendChild(filesWrapper);
                            filesDiv.appendChild(objWrapper);
                            filesDiv.parentElement.style.display = 'block';
                        } else {
                            noFiles.style.display = 'block';
                        }
                    });
                } else {
                    noFiles.style.display = 'block';
                }
            };
        } else {
            cityValue.length === 0 && citySelect.classList.add('downloads-error');
            statusValue.length === 0 && statusSelect.classList.add('downloads-error');
        }
        if (statusValue === 'opt1') {
            noFiles.textContent =
                'W tej chwili brak dokumentów do wyświetlenia. Odwiedź zakładkę oferta.';
        } else {
            noFiles.textContent = 'W tej chwili brak dokumentów do wyświetlenia';
        }
    });
}
